import { isEmptyDocument } from '@atlaskit/editor-common/utils/document';
import { Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';

import type {
	AppendNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

export const createAppendNodeToEndCommand: StreamingCommandFactory<AppendNodeCommand> =
	(api) => () => {
		return api.core.actions.execute(({ tr }) => {
			let selection: Selection;
			if (isEmptyDocument(tr.doc)) {
				selection = Selection.atEnd(tr.doc);
			} else {
				const $pos = tr.doc.resolve(tr.doc.content.size);
				tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
				selection = TextSelection.create(tr.doc, $pos.pos + 1);
			}
			if (!selection) {
				throw new Error('Failed to create selection');
			}
			tr.setSelection(selection).scrollIntoView();
			return tr;
		});
	};
